/**
 * ## Grid Event Types
 *
 * Event types to register functions on grids.
 * @since 4.0.0
 * @example
 * ```JavaScript
 * // access the enum
 * DMS.Events.GridEventTypes.FilterCollapsed
 *
 * // register on a grid
 * $dms(".dms-grid").on(DMS.Events.GridEventTypes.FilterCollapsed, function() { alert('clicked') });
 * ```
 */
export enum GridEventTypes {
    /**
     * Occurs after filter is collapsed.
     * @since 4.0.0
     */
    FilterCollapsed = 0,

    /**
     * Occurs before filter is collapsed.
     * @since 4.0.0
     */
    FilterCollapsing = 1,

    /**
     * Occurs when a grid wants to reinitialize itself by loading the new gridDefinition from the server.
     * @hidden
     */
    ReinitializeGrid = 2,

    /**
     * Occurs after grid data was finished loading.
     * @since 4.0.0
     */
    DataBound = 3,

    /**
     * Occurs after a TreeLink command was executed.
     * @since 4.0.0
     */
    TreeLinkCommandExecuted = 4,

    /**
     * Occurs after the control data was loaded.
     * @since 4.0.0
     */
    ControlDataLoaded = 5,

    /**
     * Occurs after a resize is requested
     * @since 4.0.0
     */
    ResizeRequested = 6,

    /**
     * Occurs after the height of the grid was changed.
     * @since 4.1.0
     */
    HeightChanged = 7,

    /**
     * Occurs after the user selected a grid row.
     * @since 4.5.0
     */
    SelectedRowChanged = 8,
}
